import {
	IPublicClientApplication,
	AccountInfo,
	AuthenticationResult,
	AuthorizationCodeRequest,
	ClearCacheRequest,
	ITokenCache,
	BrowserConfiguration,
	SilentRequest,
	SsoSilentRequest,
	RedirectRequest,
	PopupRequest,
	INavigationClient,
	Logger
} from '@azure/msal-browser';

/**
 * Classe permettant de démarrer tout de même une application full angular même si on est pas dans un contexte https
 */
export class FakePublicClientApplication implements IPublicClientApplication {

	private readonly fakeLogger = new Logger({
		loggerCallback: () => {},
		piiLoggingEnabled: false
	});

	getAllAccounts(): AccountInfo[] {
		return [];
	}
	getAccountByHomeId(): AccountInfo | null {
		return null;
	}
	getAccountByLocalId(): AccountInfo | null {
		return null;
	}
	getAccountByUsername(): AccountInfo | null {
		return null;
	}
	initialize(): Promise<void> {
		return Promise.resolve();
	}
	handleRedirectPromise(): Promise<AuthenticationResult | null> {
		return Promise.resolve(null);
	}
	// Méthodes d'authentification
	loginRedirect(): Promise<void> {
		return Promise.resolve();
	}
	loginPopup(): Promise<AuthenticationResult> {
		return Promise.reject('Fake MSAL: loginPopup not supported');
	}
	logout(): Promise<void> {
		return Promise.resolve();
	}
	logoutRedirect(): Promise<void> {
		return Promise.resolve();
	}
	logoutPopup(): Promise<void> {
		return Promise.resolve();
	}
	acquireTokenSilent(): Promise<AuthenticationResult> {
		return Promise.reject('Fake MSAL: acquireTokenSilent not supported');
	}
	acquireTokenPopup(): Promise<AuthenticationResult> {
		return Promise.reject('Fake MSAL: acquireTokenPopup not supported');
	}
	acquireTokenRedirect(): Promise<void> {
		return Promise.resolve();
	}
	addEventCallback(): string {
		return '';
	}
	removeEventCallback(): void {}
	addPerformanceCallback(): string {
		return '';
	}
	enableAccountStorageEvents(): void {}
	disableAccountStorageEvents(): void {}
	initializeWrapperLibrary(): void {}
	setLogger(): void {}
	getLogger(): any {
		return this.fakeLogger;
	}
	setActiveAccount(): void {}
	getActiveAccount(): AccountInfo | null {
		return null;
	}

	acquireTokenByCode(request: AuthorizationCodeRequest): Promise<AuthenticationResult> {
		return Promise.resolve(undefined);
	}

	clearCache(logoutRequest?: ClearCacheRequest): Promise<void> {
		return Promise.resolve(undefined);
	}

	getAccount(accountFilter): AccountInfo | null {
		return undefined;
	}

	getConfiguration(): BrowserConfiguration {
		return undefined;
	}

	getTokenCache(): ITokenCache {
		return undefined;
	}

	hydrateCache(result: AuthenticationResult, request: SilentRequest | SsoSilentRequest | RedirectRequest | PopupRequest): Promise<void> {
		return Promise.resolve(undefined);
	}

	removePerformanceCallback(callbackId: string): boolean {
		return false;
	}

	setNavigationClient(navigationClient: INavigationClient): void {
	}

	ssoSilent(request: SsoSilentRequest): Promise<AuthenticationResult> {
		return Promise.resolve(undefined);
	}
}
